export default __webpack_public_path__ + "static/media/Mark-3-HUD-00.f5df1e1c.jpg";